<script>
  import { fly } from "svelte/transition";
  import { getSizedImageUrl } from "@shopify/theme-images";

  export let menuItems = {};
  export let featuredProduct = {};
  export let bottomLink = {};

  let categories = menuItems.filter((menuItem) => menuItem.children.length > 0);
  const COLUMNS_COUNT = 4;
  let columns = [];

  for (let i = 0; i < COLUMNS_COUNT; i++) {
    if (categories.length > i) {
      columns.push(categories[i]);
    } else {
      columns.push(undefined);
    }
  }
</script>

<div
  class="tw-absolute tw-w-full tw-left-0 tw-top-12 tw-bg-white tw-shadow-md tw-z-20"
  in:fly={{ y: -10, duration: 200 }}
  out:fly={{ y: -10, duration: 200 }}
>
  <hr />
  <div class="tw-w-full tw-max-w-screen-xl tw-mx-auto">
    <div class="tw-px-8 tw-my-8 tw-max-h-75-screen tw-overflow-y-auto">
      <div
        class="tw-grid tw-grid-cols-6 tw-gap-4 tw-gap-y-6 tw-cursor-default tw-text-left tw-whitespace-normal"
      >
        {#each columns as column}
          <div class="tw-flex tw-flex-col">
            {#if column}
              <div class="tw-text-2xl tw-font-serif tw-font-normal tw-mb-6">
                {column.title}
              </div>
              {#each column.children as menuItem}
                <div
                  class="tw-text-xs tw-uppercase tw-font-sans tw-font-medium tw-tracking-widest tw-leading-tight tw-mb-4 tw-max-w-full"
                >
                  <a
                    href={menuItem.url}
                    class="tw-cursor-pointer hover:tw-text-green-400"
                    >{menuItem.title}</a
                  >
                </div>
              {/each}
            {/if}
          </div>
        {/each}
        <div class="tw-col-span-2">
          <a href={featuredProduct.url} class="tw-cursor-pointer">
            <img
              class="tw-w-full"
              src={getSizedImageUrl(featuredProduct.imageSrc, "512x")}
              alt={featuredProduct.label}
            />
          </a>
        </div>
        <div
          class="tw-col-span-4 tw-flex-grow tw-flex tw-items-center tw-text-xs tw-uppercase tw-font-medium tw-tracking-widest tw-leading-tight tw-font-sans"
        >
          <a
            href={bottomLink.url}
            class="tw-underline tw-cursor-pointer hover:tw-text-green-400"
            >{bottomLink.text}</a
          >
        </div>
        <a
          href={featuredProduct.ctaUrl}
          class="tw-col-span-2 tw-w-full tw-flex-grow tw-flex tw-items-center tw-justify-between tw-text-xs tw-uppercase tw-font-medium tw-tracking-widest tw-leading-tight tw-font-sans tw-cursor-pointer hover:tw-text-green-400"
        >
          <div class="tw-mr-2">
            {featuredProduct.label}
          </div>
          <div
            class="tw-block tw-flex tw-flex-row tw-items-center tw-justify-center"
          >
            <span>{featuredProduct.ctaText}</span>
            <img
              class="tw-border tw-border-black tw-border-solid tw-rounded-full tw-p-2 tw--mt-1 tw-ml-2"
              src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/arrow-right.svg?v=1602849460"
              alt="arrow"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
